(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('CompanyInvoiceInfoDialogController', CompanyInvoiceInfoDialogController);

    CompanyInvoiceInfoDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'CompanyInvoiceInfo', 'Company', 'PersonInfo', 'CompanyCustom', 'PersonInfoQuery'];

    function CompanyInvoiceInfoDialogController($timeout, $scope, $stateParams, $uibModalInstance, entity, CompanyInvoiceInfo, Company, PersonInfo, CompanyCustom, PersonInfoQuery) {
        var vm = this;

        vm.companyInvoiceInfo = entity;
        vm.clear = clear;
        vm.save = save;
        vm.findCompany = findCompany;
        vm.newItem = newItem;
        vm.onFieldChanged = onFieldChanged;


        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if (vm.companyInvoiceInfo.id !== null) {
                CompanyInvoiceInfo.update(vm.companyInvoiceInfo, onSaveSuccess, onSaveError);
            } else {
                CompanyInvoiceInfo.save(vm.companyInvoiceInfo, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('tikonApp:CompanyInvoiceInfoUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function findCompany() {

            if (vm.companyKeyUrl != null && vm.companyKeyUrl != undefined) {
                var c = CompanyCustom.findCompanyByKeyURL(vm.companyKeyUrl).query(function (c) {
                    if (c != null && c != undefined) {
                        vm.companyInvoiceInfo.company = c;
                        vm.companyInvoiceInfo.companyId = vm.companyInvoiceInfo.company.id;
                    }
                });

            }

        }

        function newItem() {
            var newItem = {};
            newItem.title = 'عنوان';
            newItem.price = 0;
            newItem.qty = 1;


            if (!vm.companyInvoiceInfo.companyInvoiceInfoItems)
                vm.companyInvoiceInfo.companyInvoiceInfoItems = [];

            vm.companyInvoiceInfo.companyInvoiceInfoItems.push(newItem);
        }


        function onFieldChanged() {
            computeFinalPrice();
        }

        function computeFinalPrice() {

            if (vm.companyInvoiceInfo.discount == undefined)
                vm.companyInvoiceInfo.discount = 0;

            vm.companyInvoiceInfo.subscriptionPrice = 0;
            // vm.companyInvoiceInfo.discount = 0;
            vm.companyInvoiceInfo.finalPrice = 0;

            if (!vm.companyInvoiceInfo.companyInvoiceInfoItems)
                return;

            angular.forEach(vm.companyInvoiceInfo.companyInvoiceInfoItems, function (item) {
                vm.companyInvoiceInfo.subscriptionPrice += item.price * item.qty;
            })

            vm.companyInvoiceInfo.finalPrice = vm.companyInvoiceInfo.subscriptionPrice - vm.companyInvoiceInfo.discount;

        }
    }
})();
